import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import Global from '../../../../store/global-selectors';
import { ActionablePlaceholder } from 'ui-components/components/display-grid/actionable-placeholder';

import { ltlShipmentsGridMessages } from './messages';

export const LtlShipmentsGridPlaceholder = () => {
  const history = useHistory();
  const providers = useSelector(Global.selectFreightSettingsProviders);
  const hasConnectedProvider = providers.some((provider) => provider.isConnected);

  const handleConnectProvider = useCallback(() => {
    history.push('/settings/freightproviders');
  }, [history]);

  if (!hasConnectedProvider) {
    return (
      <ActionablePlaceholder
        action={handleConnectProvider}
        buttonContent={<FormattedMessage {...ltlShipmentsGridMessages.noProviderButton} />}
        description={<FormattedMessage {...ltlShipmentsGridMessages.noProviderDescription} />}
        title={<FormattedMessage {...ltlShipmentsGridMessages.noProviderTitle} />}
      />
    );
  }

  return (
    <ActionablePlaceholder
      description={<FormattedMessage {...ltlShipmentsGridMessages.noShipmentsDescription} />}
      title={<FormattedMessage {...ltlShipmentsGridMessages.noShipmentsTitle} />}
    />
  );
};
